import React, { useContext } from 'react';
import { Navigate} from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {

    const { currentUser, user } = useContext(AuthContext);


    if (!!currentUser) {
    
        if(!user.emailVerified){
            return <Navigate to='/auth' />
        }

        return children;
    }
    if (currentUser === 0)
        return <Navigate to='/auth' />

};

export default PrivateRoute;
